<template>
    <div>
        <EditTrimInfoModal v-if="displayModal"
                           :trim="trimData"
                           @save="setTrimNewInfo"
                           @closeModal="closeModal"
        ></EditTrimInfoModal>

        <ButtonCircle @click="openModal" :disabled="disabled" :title="'Edit trim info'">
            <i class="icon-pencil"></i>
        </ButtonCircle>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    import EditTrimInfoModal from "../../components/modals/EditTrimInfoModal";
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "EditTrimInfo",

        components: {
            ButtonCircle,
            EditTrimInfoModal
        },

        props: [
            'disabled',
        ],

        data() {
            return {
                displayModal: false,
            }
        },

        computed: {
            ...mapState('trimInfo', [
                'trimId',
                'trimName',
                'description',
            ]),

            trimData() {
                let id = this.trimId;
                let trimName = this.trimName.trim();
                let description = this.description.trim();

                let data = {
                    id,
                    trimName,
                    description,
                };

                return data;
            },

        },

        methods: {
            ...mapMutations('trimInfo', [
                'setTrimName',
                'setTrimDescription',
            ]),

            openModal() {
                this.displayModal = true;
            },

            closeModal() {
                this.displayModal = false;
            },

            setTrimNewInfo(trim) {
                let trimName = trim.trimName;
                let description = trim.description;

                this.setTrimName(trimName);
                this.setTrimDescription(description);
            },

        },

    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }
</style>